var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.38 0 0 5.38 0 12C0 18.62 5.38 24 12 24C18.62 24 24 18.62 24 12C24 5.38 18.62 0 12 0ZM9.19 16.59H6.91V9.74H9.19V16.59ZM8.05 8.81H8.03C7.26 8.81 6.77 8.28 6.77 7.62C6.77 6.96 7.28 6.44 8.06 6.44C8.84 6.44 9.32 6.95 9.33 7.62C9.33 8.28 8.84 8.81 8.04 8.81H8.05ZM17.39 16.59H15.11V12.93C15.11 12.01 14.78 11.38 13.96 11.38C13.33 11.38 12.96 11.8 12.79 12.21C12.73 12.36 12.71 12.56 12.71 12.76V16.58H10.44C10.44 16.58 10.47 10.38 10.44 9.73H12.71V10.7C13.01 10.24 13.55 9.57 14.76 9.57C16.26 9.57 17.38 10.55 17.38 12.65V16.58L17.39 16.59Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.3dddd18a227439314bb7fb697f47c7f3.svg";
export { ForwardRef as ReactComponent };